import { render, staticRenderFns } from "./EngineFaultsDataNewRules.vue?vue&type=template&id=288b8f68&scoped=true"
import script from "./EngineFaultsDataNewRules.vue?vue&type=script&lang=js"
export * from "./EngineFaultsDataNewRules.vue?vue&type=script&lang=js"
import style0 from "./EngineFaultsDataNewRules.vue?vue&type=style&index=0&id=288b8f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b8f68",
  null
  
)

export default component.exports